import { Permission, Resource } from '../constants/permissions';
import { usePermissions } from '../hooks/usePermissions';

export const getPermissionErrorMessage = (
  action: string,
  resource: string
): string => {
  return `You don't have permission to ${action} ${resource}. Please contact your administrator.`;
};

export const usePermissionErrorHandler = () => {
  const { can } = usePermissions();

  const checkPermissionAndShowError = (
    resource: Resource,
    permission: Permission,
    action: string,
    showToast: (message: string, type?: 'error' | 'success' | 'warning') => void
  ): boolean => {
    if (!can(resource, permission)) {
      const errorMessage = getPermissionErrorMessage(action, resource);
      showToast(errorMessage, 'error');
      return false;
    }
    return true;
  };

  return {
    checkPermissionAndShowError,
    getPermissionErrorMessage,
  };
}; 